import branchManagementContactRequestComponent from './contact_request.component';
import PrintModule from './print';

let branchManagementContactRequestModule = angular.module('branchManagementContactRequest', [PrintModule])
    .component('branchManagementContactRequest', branchManagementContactRequestComponent)
    .name;

export default branchManagementContactRequestModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/contact_request/index.js